<template>
  <div id="app">
    <div v-if="$root.loadApp">
      <v-loading v-if="$root.showLoading" :texto="$root.textLoading"></v-loading>
      <header-component></header-component>

      <transition name="slide-fade" mode="out-in">
        <router-view />
      </transition>
      <botao-contato></botao-contato>
      <footer-component></footer-component>
      <div id="form-transparent" style="display: none;"></div>
    </div>
    <div v-else>
      <v-loading v-if="$root.showLoading" :texto="$root.textLoading"></v-loading>
    </div>
  </div>
</template>

<script>
import HeaderComponent from './components/includes/Header.vue'
import FooterComponent from './components/includes/Footer.vue'
import BotaoContato from './components/includes/BotaoContato.vue'

export default {
  name: 'App',
  components: {
    HeaderComponent,
    FooterComponent,
    BotaoContato,
  },
  beforeCreate() {
    console.info('Carregando App...')

    let token = this.$route.query.token
    let refresh_token = this.$route.query.refresh_token
    if (token) {
      localStorage.setItem('token', token)
      localStorage.setItem('refresh_token', refresh_token)
      localStorage.removeItem('fastLogin')
    }

    this.$root.refreshToken()

    $(() => {
      $.modal.defaults.fadeDuration = 500
    })

    //      this.$cookie.delete('carrinho')
    // pega o carrinho atual no Cookie
    //let carrinho = this.$cookie.get('carrinho')
    let carrinho = localStorage.getItem('carrinho')
    this.$store.dispatch('changeCarrinho', carrinho ? JSON.parse(carrinho) : [])
  }
}
</script>

<style lang="css">
@import "assets/css/app.css";

.slide-fade-slow-enter-active {
  transition: all 1s ease;
}

.slide-fade-slow-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-slow-enter,
.slide-fade-slow-leave-to {
  transform: translateX(20px);
  opacity: 0;
}

.slide-fade-enter-active {
  transition: all .1s ease;
}

.slide-fade-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(20px);
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .2s
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active in <2.1.8 */
  {
  opacity: 0
}

.dropdown-toggle::after {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue